
/* eslint-disable max-len */

export default `
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path class="stroke" d="M11 6C11.7278 4.25221 13.6916 3 16 3C18.3084 3 20.2722 4.25221 21 6"  stroke-width="2" stroke-linecap="round"/>
    <path class="stroke" d="M28 9H4"  stroke-width="2" stroke-linecap="round"/>
    <path class="stroke" d="M25 12L24.3942 21.3828C24.1611 24.9935 24.0446 26.7988 22.9053 27.8994C21.766 29 20.0138 29 16.5093 29H15.4907C11.9862 29 10.234 29 9.09473 27.8994C7.95545 26.7988 7.83889 24.9935 7.60578 21.3828L7 12"  stroke-width="2" stroke-linecap="round"/>
    <path class="stroke" d="M12.5 15L13 24"  stroke-width="2" stroke-linecap="round"/>
    <path class="stroke" d="M19.5 15L19 24"  stroke-width="2" stroke-linecap="round"/>
  </svg>
`
